<header class="header">
  <span class="header__quantity" *ngIf="menuItemsInCart">
    {{ cartStore.totalQuantity }} items in cart
  </span>
  <button
    class="header__close-btn"
    (click)="goPrevPage()"
    title="Close the cart"
  >
    <svg class="header__icon">
      <use
        xlink:href="./assets/images/icons-sprite.svg#icon-close"
      ></use>
    </svg>
  </button>
</header>

<div class="container">
  <p
    *ngIf="!(cartStore.items$ | async).length; else cartContent"
    class="empty-cart"
  >
    No items in your Cart! 😢
  </p>
  <ng-template #cartContent>
    <ul class="menu-list" *ngIf="menuItemsInCart">
      <li
        *ngFor="let menuItem of menuItemsInCart; index as i"
        class="menu-item"
      >
        <div class="menu-item__info">
          <figure class="menu-item__figure">
            <button
              type="button"
              (click)="deleteItemFromCart(i)"
              class="menu-item__delete-btn"
              title="Delete the item"
            >
              <svg class="menu-item__icon">
                <use
                  xlink:href="./assets/images/icons-sprite.svg#icon-cancel"
                ></use>
              </svg>
            </button>
            <img
              src="{{ menuItem.item.image || defaultImage }}"
              class="menu-item__image"
            />
          </figure>
          <div class="menu-item__content">
            <p class="menu-item__name">{{ menuItem.item.name }}</p>
            <p class="menu-item__desc">{{ menuItem.item.variation.name }}</p>
            <p class="menu-item__modifiers">
              <span *ngFor="let modifier of menuItem.item.modifiers; index as i"
                class="menu-item__modifier" [hidden]="!modifier.hiddenFromCustomer">
                  {{ modifier.name.trim() }}{{ i < menuItem.item.modifiers.length - 1 ? ",  " : "" }}
              </span>
            </p>
          </div>
        </div>
        <div class="menu-item__price-wrapper">
        <div class="menu-item__counter">
          <button (click)="changeQuantity(menuItem.item,false)" [ngClass]="{'disabled-button': menuItem.item.quantity === 1}"
            class="left-button">
              -
          </button>
          <span>{{menuItem.item.quantity}}</span>
          <button (click)="changeQuantity(menuItem.item, true)" class="right-button">
            +
          </button>
        </div>
        <div class="menu-item__price">
          <span>${{
              getFormattedPrice(menuItem.item.totalItemPrice.amount / 100, menuItem.item.quantity)
            }}</span
          >
        </div>
        </div>
      </li>
    </ul>

    <div *ngIf="restaurant.allowScheduledPickups" class="scheduled-pickup-timepicker__container">
      <div class="scheduled-pickup-timepicker__title-wrapper">
        <span class="scheduled-pickup-timepicker__title">Select a date/time to pick up your order</span>
      </div>
      <app-scheduled-pickup-timepicker [hoursOfOperation]="restaurant.hoursOfOperation"></app-scheduled-pickup-timepicker>
    </div>

    <div class="price">
      <div class="price__block">
        <span class="price__label">Subtotal</span>
        <span class="price__amount">${{ getFormattedPrice(cartStore.totalPrice - cartStore.totalTaxesPrice) }}</span>
      </div>

      <div class="price__block" *ngIf="cartStore.totalPrice > 0.99">
<!--    TODO: added kyyo_fee to base taxes value    -->
        <span class="price__label">Taxes & fees</span>
        <span class="price__amount">${{ getFormattedPrice(cartStore.totalTaxesPrice) }}</span>
      </div>

      <!-- <div class="price__block" *ngIf="!showTips && cartStore.autoGratuityTaxes === 0">
        <span class="price__label">Auto gratuity ({{ cartStore.autoGratuityText }})</span>
        <span class="price__amount">${{ getFormattedPrice(cartStore.autoGratuityTaxes) }}</span>
      </div> -->

      <div class="price__block">
        <span class="price__label">
          Driver Tip
          <span *ngIf="cartStore.autoGratuityPercent !== 0">{{ ' (' + (getFormattedTip(tip.driver) | number:'0.0-0') + '%)' }}</span>
          <button
            type="button"
            *ngIf="!showDriverTip"
            class="edit-tip-button"
            (click)="showDriverTip = true;">
            Edit
          </button>
        </span>
        <span class="price__amount">${{ getFormattedPrice(cartStore.getTip(tip.driver)) }}</span>
      </div>

      <div class="price__block">
        <span class="price__label">
          Restaurant Tip
          <span *ngIf="cartStore.autoGratuityPercent !== 0">{{ ' (' + (getFormattedTip(tip.restaurant) | number:'0.0-0') + '%)' }}</span>
          <button
            type="button"
            *ngIf="!showTipsExpanded"
            class="edit-tip-button"
            (click)="showTipsExpanded = true;">
            Edit
          </button>
        </span>
        <span class="price__amount">${{ getFormattedPrice(cartStore.getTip(tip.restaurant)) }}</span>
      </div>


      <div class="price__divider"></div>
      <div class="price__block">
        <span class="price__label price__label--total">Total</span>
        <span class="price__amount price__amount--total">
          ${{ getFormattedPrice(cartStore.totalPrice + cartStore.tips)}}
        </span>
      </div>
    </div>
  </ng-template>
</div>

<app-checkout-btn [disabled]="!getAvailable()">Confirm</app-checkout-btn>
